<template>
  <layout-main-inner title="商家标签管理">
    <layout-card-wrap>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick">
        <el-tab-pane
          label="防伪扣/证书申请发放"
          name="1">
          <tag-apply-table ref="table1" />
        </el-tab-pane>
        <el-tab-pane
          label="商家使用汇总"
          name="2">
          <vendor-used-table ref="table2" />
        </el-tab-pane>
      </el-tabs>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import TagApplyTable from './busi/tag-apply-table.vue'
import VendorUsedTable from './busi/vendor-used-table.vue'
export default {
  name: 'AppraisalTagIndex',
  components: { TagApplyTable, VendorUsedTable },
  data() {
    return {
      loading: true,
      activeName: '1'
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  methods: {
    handleClick(tab) {
      console.log(tab)
      // this.$refs['table' + tab.name].handleCurrentChange(1)
    }
  }
}
</script>
<style lang="stylus">
.tab-inner-form {
  display flex;
  align-items center;
  justify-content space-between;
  margin-bottom 15px
}
</style>
